var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCpu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 512 512",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 256,
    y1: 466,
    x2: 256,
    y2: 72.528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.322,
    stopColor: "#a163f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.466,
    stopColor: "#b074ee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.752,
    stopColor: "#d8a1dd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.898,
    stopColor: "#efbad3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 255.878,
    y1: 466,
    x2: 255.878,
    y2: 72.528,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 120,
    y1: 466,
    x2: 120,
    y2: 72.528,
    xlinkHref: "#linear-gradient"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M256,168.03a87.47,87.47,0,1,0,87.47,87.47A87.569,87.569,0,0,0,256,168.03Zm0,162.94a75.47,75.47,0,1,1,75.47-75.47A75.556,75.556,0,0,1,256,330.97Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,134.5a121,121,0,1,0,121,121A121.137,121.137,0,0,0,256,134.5ZM358.207,262h6.625a109.2,109.2,0,0,1-27.671,66.425l-4.646-4.771a5.968,5.968,0,1,0-8.487,8.391l4.647,4.632A108.549,108.549,0,0,1,262,364.333v-6.626a6,6,0,0,0-12,0v6.626a108.565,108.565,0,0,1-66.675-27.672l4.647-4.647a6,6,0,0,0-8.487-8.485l-4.646,4.9A109.2,109.2,0,0,1,147.168,262h6.625a6,6,0,0,0,0-12h-6.625a108.153,108.153,0,0,1,27.671-66.925l4.646,4.521a5.917,5.917,0,0,0,4.244,1.695A6.04,6.04,0,0,0,187.972,179l-4.647-4.654A108.573,108.573,0,0,1,250,146.667v6.626a6,6,0,0,0,12,0v-6.626a108.565,108.565,0,0,1,66.675,27.672l-4.647,4.647a6,6,0,0,0,8.487,8.485l4.646-4.4A108.153,108.153,0,0,1,364.832,250h-6.625a6,6,0,0,0,0,12Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.7,237.4A23.876,23.876,0,0,0,267,213.2v-6.884a6,6,0,1,0-12,0V213h-8v-6.682a6,6,0,1,0-12,0V213h-5.939a6,6,0,0,0,0,12H233v62h-3.939a6,6,0,0,0,0,12H235v5.682a6,6,0,0,0,12,0V299h8v5.682a6,6,0,0,0,12,0v-6.313a23.876,23.876,0,0,0,21.7-24.2,24.328,24.328,0,0,0-8.391-18.382A24.33,24.33,0,0,0,288.7,237.4ZM264.557,287H245V262h19.557a12.5,12.5,0,0,1,0,25Zm0-37H245V225h19.557a12.5,12.5,0,0,1,0,25Z",
    style: {
      fill: "url(#linear-gradient-3)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M436.434,162a20.568,20.568,0,0,0,20.031-15H492a6,6,0,0,0,0-12H456.465c-2.587-8-10.583-15-20.031-15H419.791A34.343,34.343,0,0,0,391,91.708V75.066a20.566,20.566,0,0,0-15-20.03V20.5a6,6,0,0,0-12,0V55.035c-8,2.586-15,10.583-15,20.031V91H334V75.066a20.566,20.566,0,0,0-15-20.03V20.5a6,6,0,0,0-12,0V55.035a20.567,20.567,0,0,0-15,20.031V91H277V75.066a21.019,21.019,0,0,0-15-20.03V20.5a6,6,0,0,0-12,0V55.035a21.021,21.021,0,0,0-15,20.031V91H220V75.066a20.567,20.567,0,0,0-15-20.031V20.5a6,6,0,0,0-12,0V55.036a20.566,20.566,0,0,0-15,20.03V91H163V75.066c0-9.448-7-17.444-15-20.031V20.5a6,6,0,0,0-12,0V55.035a20.568,20.568,0,0,0-15,20.031V91.708A34.343,34.343,0,0,0,92.209,120H75.566c-9.448,0-17.444,7-20.031,15H20a6,6,0,0,0,0,12H55.535a20.567,20.567,0,0,0,20.031,15H92v16H75.566c-9.448,0-17.444,6-20.031,14H20a6,6,0,0,0,0,12H55.535a20.566,20.566,0,0,0,20.031,15H92v16H75.566a20.568,20.568,0,0,0-20.031,15H20a6,6,0,0,0,0,12H55.535c2.586,8,10.582,14,20.031,14H92v16H75.566a20.568,20.568,0,0,0-20.031,15H20a6,6,0,0,0,0,12H55.535c2.587,8,10.583,14,20.031,14H92v16H75.566a20.568,20.568,0,0,0-20.031,15H20a6,6,0,0,0,0,12H55.535c2.587,8,10.583,15,20.031,15H92.209A34.341,34.341,0,0,0,121,419.291v16.643a20.566,20.566,0,0,0,15,20.03V491.5a6,6,0,0,0,12,0V455.965c8-2.586,15-10.583,15-20.031V420h15v15.934a20.566,20.566,0,0,0,15,20.03V491.5a6,6,0,0,0,12,0V455.965a20.567,20.567,0,0,0,15-20.031V420h15v15.934a21.019,21.019,0,0,0,15,20.03V491.5a6,6,0,0,0,12,0V455.965a21.021,21.021,0,0,0,15-20.031V420h15v15.934a20.567,20.567,0,0,0,15,20.031V491.5a6,6,0,0,0,12,0V455.964a20.566,20.566,0,0,0,15-20.03V420h15v15.934c0,9.448,7,17.444,15,20.031V491.5a6,6,0,0,0,12,0V455.965a20.568,20.568,0,0,0,15-20.031V419.291A34.341,34.341,0,0,0,419.791,391h16.643c9.448,0,17.444-7,20.031-15H492a6,6,0,0,0,0-12H456.465a20.566,20.566,0,0,0-20.031-15H420V333h16.434c9.448,0,17.444-6,20.031-14H492a6,6,0,0,0,0-12H456.465a20.566,20.566,0,0,0-20.031-15H420V276h16.434c9.448,0,17.444-6,20.031-14H492a6,6,0,0,0,0-12H456.465a20.566,20.566,0,0,0-20.031-15H420V219h16.434a20.568,20.568,0,0,0,20.031-15H492a6,6,0,0,0,0-12H456.465c-2.587-8-10.583-14-20.031-14H420V162ZM420,132h16.434a9,9,0,0,1,0,18H420ZM92,379H75.566a9,9,0,0,1,0-18H92Zm0-58H75.566c-4.917,0-8.918-3.583-8.918-8.5s4-8.5,8.918-8.5H92Zm0-57H75.566c-4.917,0-8.918-3.583-8.918-8.5s4-8.5,8.918-8.5H92Zm0-57H75.566c-4.917,0-8.918-3.583-8.918-8.5s4-8.5,8.918-8.5H92Zm0-57H75.566a9,9,0,0,1,0-18H92ZM361,75.066a9,9,0,0,1,18,0V91H361Zm-57,0a9,9,0,0,1,18,0V91H304Zm-57,0a9,9,0,0,1,18,0V91H247Zm-57,0a9,9,0,0,1,18,0V91H190Zm-57,0a9,9,0,0,1,18,0V91H133Zm18,360.868a9,9,0,0,1-18,0V420h18Zm57,0a9,9,0,0,1-18,0V420h18Zm57,0a9,9,0,0,1-18,0V420h18Zm57,0a9,9,0,0,1-18,0V420h18Zm57,0a9,9,0,0,1-18,0V420h18Zm29-50.861A21.927,21.927,0,0,1,386.073,407H125.927A21.927,21.927,0,0,1,104,385.073V124.927A21.927,21.927,0,0,1,125.927,103H386.073A21.927,21.927,0,0,1,408,124.927ZM436.434,361a9,9,0,0,1,0,18H420V361Zm0-57c4.917,0,8.918,3.583,8.918,8.5s-4,8.5-8.918,8.5H420V304Zm0-57c4.917,0,8.918,3.583,8.918,8.5s-4,8.5-8.918,8.5H420V247Zm0-57c4.917,0,8.918,3.583,8.918,8.5s-4,8.5-8.918,8.5H420V190Z",
    style: {
      fill: "url(#linear-gradient)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,125.558a6,6,0,0,0-6,6v3.768a6,6,0,0,0,12,0v-3.768A6,6,0,0,0,120,125.558Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120,150.325a6,6,0,0,0-6,6v53.686a6,6,0,0,0,12,0V156.325A6,6,0,0,0,120,150.325Z",
    style: {
      fill: "url(#linear-gradient-5)"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpu);
export default __webpack_public_path__ + "static/media/cpu.1a692a595e2b715afacf36d9f44e2c13.svg";
export { ForwardRef as ReactComponent };